module.exports = __webpack_public_path__ + "img/coming_soon_text.dc17395c.svg";